
export enum DeactiveShowType {
  Avatar,
  Card
}
